export default __webpack_public_path__ + "static/media/icon-prev.3bf912ee.svg";